import httpRequest from '../../utils/HttpRequest';
import { urls } from '../../config/url';

export function exitUsername(username: string) {
    return httpRequest(urls.userexist, { USER_NAME: username })
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return;
            } else {
                throw new Error(data.errmsg);
            }
        });
}

export function checkUsername(username: string) {
    if (!/^[a-zA-Z][a-zA-Z0-9_]{5,14}$/.test(username.toString())) {
        return Promise.reject(new Error('* 6~15个字符，可使用字母、数字、下划线，需以字母开头'))
    }
    return Promise.resolve();
}

export function checkUsername1(username: string) {
    if (!/^[a-zA-Z][a-zA-Z0-9_]{5,14}$/.test(username.toString())) {
        return Promise.reject(new Error('* 6~15个字符，可使用字母、数字、下划线，需以字母开头'))
    }
    return Promise.resolve();
}
export function checkPassword(pass: string) {
    const passStr = pass.toString();
    
    if (
        /\d/.test(passStr) &&
        /[A-Za-z]/.test(passStr) &&
        /^[\s\S]{8,28}$/.test(passStr) && !(passStr.indexOf(' ') !== -1)) {
        return Promise.resolve();
    }
    return Promise.reject(new Error('* 密码必须包含数字、字母且长度为8至28个字符'))
}

export function exitEmail(email: string) {
    return httpRequest(urls.mailexist, { USER_MAIL: email })
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return;
            } else {
                throw new Error(data.errmsg);
            }
        });
}

export function exitPhone(phone: string | undefined | number) {
    if (!phone) {
        return Promise.resolve();
    }
    return httpRequest(urls.phoneexist, { USER_PHONE: phone })
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return Promise.resolve();
            } else {
                throw new Error(data.errmsg);
            }
        });
}


export function checkPhone(phone: string | undefined | number) {
    const regex = /^1[3-9]\d{9}$/;  
    if (!phone) {
        return Promise.resolve();
    }
    if (!regex.test(phone.toString())) {
        return Promise.reject(`请输入正确的电话号码`);
    }
    return Promise.resolve();
}

export function checkEmail(phone: string | undefined | number) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;  
    var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
   
    if (!phone) {
        return Promise.resolve();
    }
    if (reg.test(phone.toString())) {
        return Promise.reject(`请输入正确的E-mail`);
    }
    if (!regex.test(phone.toString())) {
        return Promise.reject(`请输入正确的E-mail`);
    }
    return Promise.resolve();
}

export function register(option: {
    USER_NAME: string;
    USER_PASSWD: string;
    USER_MAIL: string;
    USER_PHONE: string;
    USER_ADDRESS: string;
    USER_COMPANY: string;
}) {
    return httpRequest(urls.userRegister, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return;
            } else {
                throw new Error(data.errmsg);
            }
        });
}

export function subUserRegister(option: {
    USER_NAME: string;
    USER_PASSWD: string;
    USER_MAIL: string;
    USER_PHONE: string;
    USER_ADDRESS: string;
    USER_COMPANY: string;
}) {
    return httpRequest(urls.subUserRegister, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return;
            } else {
                throw new Error(data.errmsg);
            }
        });
}

export function userinfo(option: {
    // USER_NAME: string;
}) {
    return httpRequest(urls.userinfo, option)
        .then(response => {
            const data = response.data;
            return data;
        });
}

export function usersubs(option: {
    // USER_NAME: string;
}) {
    return httpRequest(urls.usersubs, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return data;
            } else {
                throw new Error(data.errmsg);
            }
        });
}
export function usersubmitjobrecord(option: {
    // USER_NAME: string;
}) {
    return httpRequest(urls.usersubmitjobrecord, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return data;
            } else {
                throw new Error(data.errmsg);
            }
        });
}
export function specialtytechclass(option: {
    // USER_NAME: string;
}) {
    return httpRequest(urls.specialtytechclass, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return data;
            } else {
                throw new Error(data.errmsg);
            }
        });
}
export function useraction(option: {
    // USER_NAME: string;
}) {
    return httpRequest(urls.useraction, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return data;
            } else {
                throw new Error(data.errmsg);
            }
        });
}
export function jobqueuestatus(option: {
    // USER_NAME: string;
}) {
    return httpRequest(urls.jobqueuestatus, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return data;
            } else {
                throw new Error(data.errmsg);
            }
        });
}
export function delsubuser(option: {
    // USER_NAME: string;
}) {
    return httpRequest(urls.delsubuser, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return data;
            } else {
                throw new Error(data.errmsg);
            }
        });
}
export function usermodifypasswd(option: {
    // USER_NAME: string;
}) {
    return httpRequest(urls.usermodifypasswd, option)
        .then(response => {
            const data = response.data;
            if (data.errno === 0) {
                return data;
            } else {
                throw new Error(data.errmsg);
            }
        });
}